import { render } from "./ZamgPinRemove.vue?vue&type=template&id=7473dc92&ts=true"
import script from "./ZamgPinRemove.vue?vue&type=script&lang=ts"
export * from "./ZamgPinRemove.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__